// Redirector.tsx
import {FC, useContext, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {AuthContext} from '../Contexts/AuthContext';
import {useTranslation} from "react-i18next";
import {hasOrganizerWorkspaceAccess} from "../Static/OrganizerRoles";

export const Redirector: FC = () => {
    const navigate = useNavigate();
    const {auth} = useContext(AuthContext);
    const {t} = useTranslation();

    useEffect(() => {
        if (hasOrganizerWorkspaceAccess(auth?.roles)) {
            navigate('/Admin/Events');
        } else if (!!auth?.parsedToken) {
            navigate('/Login', {state: {appEntryError: t("redirector.unknownRoleForUsingApp")}});
        } else {
            navigate('/Login');
        }
    }, [auth, navigate, t]);

    return null;
}
